import type { ReactNode } from "react";
import { FileJs, FilePy } from "@phosphor-icons/react";
import { useThemeStore, type LanguageMode } from "../../app/stores/themeStore";
import styles from "./LanguageSwitch.module.css";

const MODES: { id: LanguageMode; label: string; icon: ReactNode }[] = [
  { id: "python", label: "Python", icon: <FilePy weight="fill" size={16} /> },
  { id: "js", label: "JavaScript", icon: <FileJs weight="fill" size={16} /> },
];

export function LanguageSwitch() {
  const languageMode = useThemeStore((s) => s.languageMode);
  const setLanguageMode = useThemeStore((s) => s.setLanguageMode);

  return (
    <div className={styles.switch} role="group" aria-label="Editor language">
      {MODES.map((mode) => (
        <button
          key={mode.id}
          type="button"
          className={[
            styles.option,
            languageMode === mode.id ? styles.active : "",
          ]
            .filter(Boolean)
            .join(" ")}
          aria-pressed={languageMode === mode.id}
          onClick={() => setLanguageMode(mode.id)}
        >
          <span className={styles.icon} aria-hidden="true">
            {mode.icon}
          </span>
          {mode.label}
        </button>
      ))}
    </div>
  );
}
